module.exports = __webpack_public_path__ + "nosotros.12bfd9b1030e1c37a424.jpg";


//////////////////
// WEBPACK FOOTER
// /home/federicblack/public_html/GrupoCristalino/src/assets/img/nosotros.jpg
// module id = ../../../../../src/assets/img/nosotros.jpg
// module chunks = main